export default "__VITE_ASSET__BIFAkUDQ__"